import OfficialAccountDoctorList from "issara-sdk/apis/OfficialAccountDoctorList_apps_PRX";
import type DoctorSerializer from "issara-sdk/types/DoctorSerializer_core";

export type OADoctor = DoctorSerializer & { id: number };

/** The provider checkbox belongs to the OA membership, not the Doctor master. */
export const eligibleOADoctors = (members: any[], division: number): OADoctor[] => {
  const doctors = new Map<number, OADoctor>();
  for (const member of members) {
    let extra: any;
    try {
      extra = typeof member.extra === "string" ? JSON.parse(member.extra) : member.extra;
    } catch {
      continue;
    }
    const doctor = member.user_doctor;
    if (
      Number(member.division?.id ?? member.division) === division &&
      member.is_doctor === true && extra?.is_Active === true &&
      doctor?.id && doctor.is_active !== false
    ) doctors.set(Number(doctor.id), doctor);
  }
  return [...doctors.values()];
};

export const loadOADoctors = async (apiToken: string, division: number): Promise<OADoctor[]> => {
  if (!apiToken || !Number.isInteger(division) || division <= 0) return [];
  const members: any[] = [];
  let offset = 0;
  // Do not cache by master name: the same user can switch OAs during a session.
  while (true) {
    const [response, error] = await OfficialAccountDoctorList.list({
      apiToken, extra: { division }, params: { pagination_class: "limit_offset", limit: 1000, offset },
    });
    if (error || !response || !Array.isArray(response.items)) {
      throw new Error("โหลดผู้ให้บริการของ OA ไม่สำเร็จ กรุณาลองใหม่");
    }
    members.push(...response.items);
    offset += response.items.length;
    const total = Number(response.total ?? response.count);
    if (!response.next && (!Number.isFinite(total) || offset >= total)) break;
    if (response.items.length === 0) throw new Error("โหลดรายชื่อผู้ให้บริการไม่ครบ");
  }
  return eligibleOADoctors(members, division);
};

export const providerIdsOf = (doctors: OADoctor[]): Set<number> =>
  new Set(doctors.flatMap((doctor) => (doctor.provider ?? []).map(Number)));

/** Scheduling blocks can outlive a provider's OA membership or checkbox. */
export const scopeProviderBlocks = (days: any[] | null | undefined, ids: Set<number>): any[] =>
  (days ?? []).map((day) => ({
    ...day,
    providers: (day.providers ?? []).filter((entry: any) =>
      ids.has(Number(entry.dsb?.doctor_provider_id)),
    ),
  }));

export const oaDivisionOptions = (options: any[] = []) =>
  options.filter((option) => {
    const id = Number(option.value ?? option.id);
    return Number.isInteger(id) && id > 0;
  });

// core.Division.TYPE values accepted by DivisionQuerySet.for_opd_encounter().
const OPD_DIVISION_TYPES = new Set([6, 7, 8, 11, 16]);

export const opdOADivisionOptions = (options: any[] = [], opdMaster: { value: number | string }[] = []) =>
  oaDivisionOptions(options).filter((option) => option.type !== undefined
    ? OPD_DIVISION_TYPES.has(Number(option.type))
    : opdMaster.some((opd) => String(opd.value) === String(option.value ?? option.id)));
